import LandingSection from "./homePage/LandingSection";
import { AnimatedDeviceTransitions, AnimatedDeviceTypes } from "../components/AnimatedDevice";
import ShowcaseSection from "./homePage/ShowcaseSection";
import AnimatedText from "../components/AnimatedText";
import { useEffect, useRef } from "react";
import { animatedTextFadeInNoSplit, animatedTextParagraphFadeIn, animatedTextZoomInWithColor } from "../components/animatedTextPresets";
import FormSection from "./homePage/FormSection";
import Nav from "./homePage/Nav";
import { AUDIOS, LINKS, SOUNDS, testIsMobile } from "../specs";
import SoundPlayer from "../components/SoundPlayer";
import AudioPlayer from "../components/AudioPlayer";
import Link from "../components/Link";
import { AccentHlColor, BrandingHlColor, ColorDark, DesignHlColor, EngineeringHlColor, TextColor } from "./homePage/colors";

const HomePage = () => {
    const aboutSectionRef = useRef<HTMLSelectElement>(null);

    useEffect(() => {
        AudioPlayer.instance.setTracks(AUDIOS);
        SoundPlayer.instance.add(...SOUNDS);

        const isMobile = testIsMobile();
        if (!isMobile) {
            try {
                AudioPlayer.instance.play()
                    .catch(() => {
                        window.addEventListener('mousedown', () => {
                            AudioPlayer.instance.play();
                        }, { once: true });
                    })
            } catch (err) {
                window.addEventListener('mousedown', () => {
                    AudioPlayer.instance.play();
                }, { once: true });
            }
        }

    }, [])

    return <div className="hp select-none">

        <Nav />

        <LandingSection />

        <section ref={aboutSectionRef} className="hp-sec-about fx-column ai-center" id="about">
            {/* <AnimatedText className="fs-8 fw-700 px-text" {...animatedTextZoomInWithColor(color, accentHlColor)}>λ</AnimatedText> */}
            {/* <AnimatedText className="fs-8 fw-700 px-text" {...animatedTextZoomInWithColor(color, accentHlColor)}> */}
            <svg height="64" viewBox="0 0 967 716" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M676.347 13.7113C657.465 4.4975 636.976 -0.0726477 616.498 0.00087301L349.517 0.000873022C329.043 -0.0726362 308.549 4.49781 289.668 13.7113C264.021 26.227 245.821 50.431 229.338 78.8132C212.681 107.496 194.42 146.697 171.385 196.15L11.6653 539.031C-17.3303 601.278 9.58664 675.254 71.8113 704.301C89.0102 712.329 107.195 716.101 125.097 715.995H390.706C427.308 716.465 462.855 700.673 486.982 672.393C507.601 700.239 540.209 716.076 573.935 716.002H840.768C841.191 716.005 841.613 716.006 842.036 716.005C842.218 716.004 842.399 716.003 842.581 716.002H842.87V716C860.099 715.833 877.571 712.065 894.204 704.301C956.429 675.254 983.346 601.278 954.35 539.031L794.632 196.153C771.596 146.698 753.335 107.496 736.677 78.8132C720.194 50.431 701.995 26.227 676.347 13.7113ZM573.876 683.002C546.086 683.068 519.479 667.602 506.477 641.219L523.869 603.883C536.791 576.143 545.966 556.468 553.603 542.002C561.445 527.146 566.073 520.983 568.939 518.23C595.785 492.449 638.185 492.45 665.03 518.23C667.897 520.983 672.525 527.146 680.367 542.002C688.003 556.468 697.179 576.143 710.101 603.883L728.837 644.104C735.897 659.261 745.621 672.326 757.193 683.002H573.896L573.876 683.002ZM647.402 73.0259C628.205 63.658 605.764 63.658 586.567 73.0259C579.623 76.4144 569.695 85.5632 554.366 111.959C542.111 133.06 528.486 161.312 510.821 199.043L619.767 432.923C652.617 433.594 685.271 446.162 710.745 470.626C721.687 481.134 730.35 495.311 738.733 511.19C747.231 527.287 757.094 548.463 769.53 575.158L788.664 616.236C802.292 645.491 837.054 658.142 866.287 644.496C895.495 630.861 908.138 596.13 894.522 566.899L735.545 225.612C711.603 174.214 694.58 137.747 679.604 111.959C664.275 85.5632 654.346 76.4144 647.402 73.0259ZM583.398 433L492.609 238.096L401.82 433H583.398ZM386.448 466L339.447 566.899C325.831 596.13 338.474 630.861 367.682 644.496C396.916 658.142 431.678 645.491 445.305 616.236L464.438 575.163C476.874 548.465 486.738 527.288 495.236 511.19C503.619 495.311 512.282 481.134 523.224 470.626C524.882 469.033 526.571 467.492 528.288 466H386.448ZM279.619 539.031C262.482 575.821 264.876 616.708 282.547 649.995H124.878L124.764 649.996C116.415 650.054 107.9 648.31 99.7282 644.496C70.5201 630.861 57.8771 596.13 71.4929 566.899L230.47 225.612C254.412 174.214 271.435 137.747 286.412 111.959C301.741 85.5632 311.669 76.4144 318.613 73.0259C328.3 68.2987 338.809 65.9572 349.317 66.0006L349.386 66.0009H505.066C502.42 70.1538 499.836 74.4337 497.292 78.8132C480.635 107.496 462.374 146.697 439.338 196.151L439.338 196.152L279.619 539.031Z" />
            </svg>

            <AnimatedText className="ff-title mt-1 fs-3 px-text" {...animatedTextZoomInWithColor(TextColor, AccentHlColor)}>aframe.studio</AnimatedText>
            <AnimatedText className="fs-1p5 ta-c mt-2 lh-p" {...animatedTextParagraphFadeIn}>
                We're a team of dream-chasers and problem-solving aficionados of the digital world. Together, we’ll make the impossible happen for the ambitious minds that dare to dream big
            </AnimatedText>
            <AnimatedText className="fs-1p5 ta-c mt-2 lh-p" {...animatedTextParagraphFadeIn}>
                We're on a mission to bridge the gap between business and the digital realm. If you're a company that knows there's more untapped potential in your digital presence, but you're not quite sure how to unlock it, we're here to help. Let's make your digital work smarter for you
            </AnimatedText>
        </section>

        <section className="hp-sec-services fx jc-center px-text" id="services">
            <AnimatedText
                className="ff-alt fs-4 ta-c"
                itemClassName="text-gradient"
                {...animatedTextFadeInNoSplit}>
                What we do best
            </AnimatedText>
        </section>

        <ShowcaseSection
            className="--brand"
            heading="Branding"
            color={ColorDark}
            hlColor={BrandingHlColor}
            description="Sure, every brand is unique. The question is do your customers realise it? We’ll make sure they do"
            canvasBgSrc="./assets/branding-bg.png"
            canvasSize={[58, 32]}
            canvasSizeSmall={[58, 58]}
            devices={[
                {
                    pos: [264, 0],
                    posSmall: [260, 100],
                    scale: .4,
                    scaleSmall: .6,
                    elevation: 2,
                    animProps: {
                        type: AnimatedDeviceTypes.Tablet,
                        screens: [
                            { src: './assets/branding-tb-1.png', transition: AnimatedDeviceTransitions.AppSwitch },
                            { src: './assets/branding-tb-2.png', transition: AnimatedDeviceTransitions.AppSwitch },
                            { src: './assets/branding-tb-3.png', transition: AnimatedDeviceTransitions.AppSwitch },
                        ]
                    }
                },
                {
                    pos: [104, 72],
                    posSmall: [100, 282],
                    scale: .5,
                    scaleSmall: .75,
                    elevation: 3,
                    animProps: {
                        type: AnimatedDeviceTypes.Phone,
                        screens: [
                            { src: './assets/branding-ph-1.png', transition: AnimatedDeviceTransitions.AppSwitch },
                            { src: './assets/branding-ph-2.png', transition: AnimatedDeviceTransitions.AppSwitch },
                            { src: './assets/branding-ph-3.png', transition: AnimatedDeviceTransitions.AppSwitch },
                        ]
                    }
                },
            ]}
        />

        <ShowcaseSection
            className="--design"
            heading="Designing"
            color={ColorDark}
            hlColor={DesignHlColor}
            description="Experiences that move people. Function and form. Hearts and minds. We don’t think these are mutually exclusive and that’s what good design means to us"
            canvasBgSrc="./assets/design-bg.png"
            canvasSize={[58, 32]}
            canvasSizeSmall={[58, 62]}
            devices={[
                {
                    pos: [507, 194],
                    posSmall: [480, 514],
                    scale: .3,
                    scaleSmall: .45,
                    elevation: 1,
                    animProps: {
                        type: AnimatedDeviceTypes.Tablet,
                        screens: [
                            { src: './assets/design-tb2-1.png', transition: AnimatedDeviceTransitions.SlideInBottom },
                            { src: './assets/design-tb2-2.png', transition: AnimatedDeviceTransitions.SlideInLeft },
                            { src: './assets/design-tb2-3.png', transition: AnimatedDeviceTransitions.SlideInRight },
                        ]
                    }
                },
                {
                    pos: [130, 0],
                    posSmall: [200, 0],
                    scale: .4,
                    scaleSmall: .6,
                    elevation: 2,
                    animProps: {
                        type: AnimatedDeviceTypes.Tablet,
                        screens: [
                            { src: './assets/design-tb1-1.png', transition: AnimatedDeviceTransitions.AppSwitch },
                            { src: './assets/design-tb1-2.png', transition: AnimatedDeviceTransitions.SlideInRight },
                            { src: './assets/design-tb1-3.png', transition: AnimatedDeviceTransitions.SlideInRight },
                            { src: './assets/design-tb1-4.png', transition: AnimatedDeviceTransitions.SlideInRight },
                        ]
                    }
                },
                {
                    pos: [0, 72],
                    posSmall: [0, 190],
                    scale: .5,
                    scaleSmall: .75,
                    elevation: 3,
                    animProps: {
                        type: AnimatedDeviceTypes.Phone,
                        screens: [
                            { src: './assets/design-ph-1.png', transition: AnimatedDeviceTransitions.AppSwitch },
                            { src: './assets/design-ph-2.png', transition: AnimatedDeviceTransitions.FadeInScrollOut },
                            { src: './assets/design-ph-3.png', transition: AnimatedDeviceTransitions.SlideInRight },
                            { src: './assets/design-ph-4.png', transition: AnimatedDeviceTransitions.AppSwitch },
                            { src: './assets/design-ph-5.png', transition: AnimatedDeviceTransitions.FadeIn },
                        ]
                    }
                },
            ]}
        />

        <ShowcaseSection
            className="--engg"
            heading="Engineering"
            color={ColorDark}
            hlColor={EngineeringHlColor}
            description="Got an awesome idea? You’re halfway there! Now let us make a fully functioning product out of it"
            canvasBgSrc="./assets/engg-bg.png"
            isLaptop
            canvasSize={[58, 32]}
            canvasSizeSmall={[58, 48]}
            devices={[{
                pos: [54, 42],
                posSmall: [0, 32],
                scale: .5,
                scaleSmall: .75,
                animProps: {
                    type: AnimatedDeviceTypes.Laptop,
                    screens: [
                        { src: './assets/engg-laptop-1.png', transition: AnimatedDeviceTransitions.AppSwitch },
                        { src: './assets/engg-laptop-2.png', transition: AnimatedDeviceTransitions.SlideInRight },
                        { src: './assets/engg-laptop-3.png', transition: AnimatedDeviceTransitions.FadeIn },
                        { src: './assets/engg-laptop-4.png', transition: AnimatedDeviceTransitions.FadeIn },
                        { src: './assets/engg-laptop-5.png', transition: AnimatedDeviceTransitions.FadeIn },
                        { src: './assets/engg-laptop-6.png', transition: AnimatedDeviceTransitions.FadeIn },
                    ]
                }
            }]}
        />

        <section className="hp-sec-culture fx-column ai-center" id="culture">
            <AnimatedText className="fs-8 fw-700 px-text" {...animatedTextZoomInWithColor(TextColor, AccentHlColor)}>∞</AnimatedText>
            <AnimatedText className="ff-title fs-3 px-text" {...animatedTextZoomInWithColor(TextColor, AccentHlColor)}>Culture</AnimatedText>
            <AnimatedText className="fs-1p5 ta-c mt-2 lh-p" {...animatedTextParagraphFadeIn}>
                We believe that the best results come from working together over the long haul, and that's exactly what we offer - Digital Partnerships. We're all in this together, chasing the same goals and sharing the same vision
            </AnimatedText>
            <AnimatedText className="fs-1p5 ta-c mt-2 lh-p" {...animatedTextParagraphFadeIn}>
                Our complete suite of Branding, Design and Engineering services all under one roof is as bespoke as the brands we partner with. That means we come up with unique solutions for your unique problems. No one-size-fits-all solutions here. And we never skimp on creativity or performance
            </AnimatedText>
        </section>

        <FormSection />

        <section className="hp-sec-footer">
            <div className="fs-1p5 ff-title">aframe.studio</div>
            <div className="__columns fx mt-3">
                <div className="fx-column fx-grow">
                    <Link href={LINKS.email}>connect@aframe.studio</Link>
                    <p className="mt-1 fs-sm text-tertiary">Melbourne, Australia</p>
                </div>
                <div className="fx-column fx-grow ai-end ta-r">
                    <div className="__links">
                        <Link href={LINKS.dribble} target="_blank">Dribble</Link>
                        <Link href={LINKS.instagram} target="_blank">Instagram</Link>
                        <Link href={LINKS.linkedIn} target="_blank">LinkedIn</Link>
                    </div>
                    <p className="mt-1 fs-sm text-tertiary">© {new Date().getFullYear()} aframe.studio | All Rights Reserved</p>
                </div>
            </div>
        </section>
    </div >
}

export default HomePage;